import { v1ApiClient } from '@/services';
import type { PathParams } from '@/shared/api/generated';

import type { QualtricsInfo } from '../model';

type QualtricsPath = '/v1/workspaces/{workspace_id}/qualtrics';

/**
 * Qualtrics 연동 정보 조회
 * API는 단일 객체를 반환하지만, ProviderContainer 호환을 위해 배열로 래핑
 */
export const getQualtricsInfo = async ({
  workspace_id,
}: PathParams<QualtricsPath, 'get'>): Promise<QualtricsInfo[]> => {
  const res = await v1ApiClient.get<QualtricsInfo>(
    `/workspaces/${workspace_id}/qualtrics`,
  );
  const data = res.data;
  return data ? [data] : [];
};
